<template>
    <div class="p-users">
        <messageController></messageController>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xs-12">
                    <!--<h1 class="text-left">Práva</h1>-->
                </div>
                <!--<h1>{{translate('Permission.text0')}}</h1>-->
                <div class="col-xs-12">
                    <table class="table table-header-rotated">
                        <thead>
                            <tr class="active height-130">
                                <th>{{translate('Permission.text1')}}</th>
                                <th class="rotate" v-for="(permission,index) in permissions" :key="'sim'+index">
                                    <div class="tool-tip">
                                        <div class="permission">{{ translate('Permission.' + permission.permission)}}</div>
                                        <!--<div class="tool-tip">

                                        </div>-->
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(org,index) in orgs" :key="'usr'+index">
                                <td>
                                    {{org.name}}
                                </td>
                                <td v-for="(permission,index) in permissions" :key="'box'+index">
                                    <div class="checkbox">
                                        <label>
                                            <input v-model="org.permissions[permission.id]" @change="setOrgPermission(org.id, permission.id, org.permissions[permission.id])" type="checkbox" >
                                        </label>
                                    </div>
                                </td>
                            </tr>
                            <tr class="height-80">
                                <td><b>{{translate('Permission.text2')}}</b></td>
                                <td :colspan="permissions.length">
                                    <vue-single-select
                                            v-model="newOrg"
                                            :options="orgsList"
                                            :required="true"
                                            option-label="name"
                                            max-height="300px"
                                    ></vue-single-select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table table-header-rotated">
                        <thead>
                            <tr class="active height-130">
                                <th>{{translate('Permission.text3')}}</th>
                                <th class="rotate" v-for="(permission,index) in permissions" :key="'sim'+index">
                                    <div class="tool-tip">
                                        <span class="permission">{{ translate('Permission.' + permission.permission)}}</span>
                                        <!--<div class="tool-tip">

                                        </div>-->
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(user,index) in users" :key="'usr'+index">
                                <td>
                                    {{user.email}}
                                </td>
                                <td v-for="(permission,index) in permissions" :key="'box'+index">
                                    <div class="checkbox" v-if="permission.id !== 'edit'">
                                        <label>
                                            <input v-model="user.permissions[permission.id]" @change="setUserPermission(user.id, permission.id, user.permissions[permission.id])" type="checkbox" >
                                        </label>
                                    </div>

                                    <div class="checkbox" v-else-if="isCreator">
                                        <label>
                                            <input v-model="user.permissions[permission.id]" @change="setUserPermission(user.id, permission.id, user.permissions[permission.id])" type="checkbox" >
                                        </label>
                                    </div>
                                    <div v-else></div>
                                </td>
                            </tr>
                            <tr>
                                <td><b>{{translate('Permission.text4')}}</b></td>
                                <td :colspan="permissions.length">
                                    <vue-single-select
                                            v-model="newUser"
                                            :options="usersList"
                                            :required="true"
                                            option-label="email"
                                            max-height="300px"
                                    ></vue-single-select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <userBar></userBar>

    </div>
</template>

<script>
    import VueSingleSelect from "vue-single-select";
    import userBar from '@/components/userBar.vue';
    import messageController from '@/components/messageController.vue';
    import loadSimId from "../mixins/loadSimId";

    export default {
        name: "Permissions",
        mixins: [loadSimId],
        components: {
            VueSingleSelect,
            userBar,
            messageController
        },
        data() {
            return {
                loaded: false,
                users: [],
                orgs: [],
                allUsers: [],
                userOrgs: [],
                usersInThisOrg: [],
                allOrgs: [],
                permissions: [],
                newOrg: '',
                newUser: ''
            }
        },
        methods:{
            async getTable(){

                const simId = this.simId;
                return this.$store.dispatch('callApi', {
                    name: 'getPermissionTable',
                    payload: {simId}
                });
            },
            async loadTable(){
                try{
                    const table = await this.getTable();
                    console.log(table);
                    this.users = table.users;
                    this.orgs = table.orgs;
                    this.allUsers = table.allUsers || [];
                    this.allOrgs = table.allOrgs || [];
                    this.permissions = table.permissions;
                    if (!this.isAdmin || !this.isCreator) {
                        let permIndex = this.permissions.indexOf(this.permissions.find(perm => perm.permission === "edit"));
                        this.permissions.splice(permIndex, 1);
                    }
                    this.filterUsers();
                    this.filterOrgs();
                    console.log(this.allUsers);
                } catch (e){
                    console.error(e);
                }                
            },
            filterUsers(){
                const used = this.users;
                this.allUsers = this.allUsers.filter(entity=>!used.some(e => e.id === entity.id));
                if (!this.isAdmin) {
                    this.allUsers = this.allUsers.filter(entity => this.usersInThisOrg.includes(entity.id));
                }

            },
            filterOrgs(){
                const used = this.orgs;
                this.allOrgs = this.allOrgs.filter(entity=>!used.some(e => e.id === entity.id));
                if (!this.isAdmin) {
                    this.allOrgs = this.allOrgs.filter(entity => this.userOrgs.includes(entity.id));
                }

            },
            async setOrgPermission(orgId, permission, value){
                const simId = this.simId;
                try{
                    await this.$store.dispatch('callApi', {
                        name: 'setOrgPermission',
                        payload: {simId, orgId, permission, value},
                    });
                    console.log('success');
                    this.$eventHub.$emit('openMessageController', 'success' , this.translate('Popups.text11'));
                } catch (e){
                    console.error(e);
                    this.$eventHub.$emit('openMessageController', 'error' , e);
                }
                this.loadTable();
            },
            async setUserPermission(userId, permission, value){
                const simId = this.simId;
                try{
                    await this.$store.dispatch('callApi', {
                        name: 'setUserPermission',
                        payload: {simId, userId, permission,value}
                    });
                    this.$eventHub.$emit('openMessageController', 'success' , this.translate('Popups.text12'));
                    console.log('success');
                    this.loadTable();
                } catch (e){
                    console.error(e);
                    this.$eventHub.$emit('openMessageController', 'error' , e);
                }
                this.loadTable();
            },
            insertToList(arr,row) {
                if (row !== null) {
                    const found = arr.some(el => el.id === row.id);
                    if (!found) {
                        arr.push(row);
                        return true;

                    } else {
                        const e =  new Error('Already in list');
                        e.name = 'alreadyInList';
                        throw e;
                    }
                }
            },
            async getUsers(){
                return this.$store.dispatch('callApi', {
                    name: 'getAllUsers'
                });
            },
            async getUserOrg() {
                let allUsers = await this.getUsers();
                this.usersInThisOrg = [];
                allUsers.map(usr => {
                    if (usr.id === this.usrId) this.userOrgs =  usr.orgs.map(org => org.id);
                });

                allUsers.map(usr => {
                    for (let u in usr.orgs) {
                        if (this.userOrgs.includes(usr.orgs[u].id)) {
                            this.usersInThisOrg.push(usr.id);
                            break;
                        }
                    }
                })
            }
        },
        async mounted(){
            this.loadSimId();
            await this.getUserOrg();
            await this.loadTable();
        },
        computed: {
            orgsList() {
                return this.allOrgs;
            },
            usersList() {
                return this.allUsers;
            },
            isCreator() {
                return this.$store.state.auth.user.creator || false;
            },
            isAdmin() {
                return this.$store.state.auth.user.isAdmin || false;
            },
            usrId() {
                return this.$store.state.auth.user.id;
            }
        },
        watch: {
            newOrg: function (val) {
                try {
                    this.insertToList(this.orgs, val);
                    this.newOrg = null;
                } catch (e) {
                    if (e.name === 'alreadyInList') {
                        this.$eventHub.$emit('openMessageController', 'error', this.translate('Popups.text13'));
                    }
                }
            },
            newUser: function (val) {
                try {
                    this.insertToList(this.users, val);
                    this.newUser = null;
                } catch (e) {
                    if (e.name === 'alreadyInList') {
                        this.$eventHub.$emit('openMessageController', 'error', this.translate('Popups.text14'));
                    }
                }
            }
        }
    }
</script>

<style  lang="css" scoped>
    .p-users {
        padding-top: 30px;
    }

    .table > tbody > tr > td {
        vertical-align: baseline;
    }

    .height-80 {
        height: 80px;
    }

    .height-130 {
        height: 130px;
    }

    .table-header-rotated {
        border-collapse: collapse;
    }
     .table-header-rotated td {
        width: 30px;
    }
     .table-header-rotated th {
         width: 50px ;


        /*padding: 5px 10px;*/
    }
    .table.table-header-rotated > thead > tr.active > th {
        background-color: transparent;
    }
    .table-header-rotated td {
        text-align: center;
        padding: 10px 5px;
        border: 1px solid #ccc;
    }
     .table-header-rotated th.rotate {
        /*height: 140px;*/
        white-space: nowrap;
         position: relative;
    }
     .table-header-rotated th.rotate > div {
        -webkit-transform: translate(/*-25px, -51px*/0,0) rotate(315deg) ;
        transform: translate(/*-25px, -51px*/0,0) rotate(315deg) ;
        width: 20px;
    }


    .tool-tip {
        /*transform: translate(!*-25px, -51px*!-100px,5px);*/
        position: relative;
        display: inline-block;
        width: 100px;
        height: 20px;
    }

    .tool-tip-text {
        -webkit-transform: translate(/*-25px, -51px*/150%,0) rotate(-315deg) ;
        transform: translate(/*-25px, -51px*/20%,-5%) rotate(-315deg) ;
        display: none;
        border: 1px solid #f5c6cb;
        min-width: 20px;
        min-height: 20px;
        background-color: #fff;
        color: #000;
        text-align: center;
        border-radius: 6px;
        padding: 10px;
        font-weight: normal;
        font-size: 12px;

        /* Position the tooltip */
        position: absolute;
        z-index: 1;
        /*top: -5px;*/
        /*left: 105%;*/
    }

    .permission {
        visibility: visible;
    }

    .rotate:hover .tool-tip-text {
        display: block;
    }



</style>
